import { getColoresTipoCitaAgenda } from "../constants/agendaColores";

export function etiquetaTipoAgenda(tipo, isDark = false) {
  const paleta = getColoresTipoCitaAgenda(isDark);
  const key = String(tipo || "otro").toLowerCase();
  return paleta[key]?.etiqueta || paleta.otro?.etiqueta || "Otro";
}

/** Enriquece nombres de usuario/agente y etiqueta de tipo para la rejilla. */
export function enriquecerCitaAgenda(cita, { usuarioPorId = {}, isDark = false } = {}) {
  if (!cita) return cita;
  const uid = cita.usuario_id != null ? String(cita.usuario_id) : "";
  const u = uid ? usuarioPorId[uid] : null;
  const agenteId = cita.agente_id ?? u?.agente_id ?? null;
  const agenteNombre = (cita.agente_nombre || u?.agente_nombre || "").trim() || null;
  return {
    ...cita,
    agente_id: agenteId,
    usuario_nombre: cita.usuario_nombre || u?.nombre || null,
    agente_nombre: agenteNombre,
    tipo_etiqueta: cita.tipo_etiqueta || etiquetaTipoAgenda(cita.tipo, isDark),
  };
}

/** Cliente (comprador) o Propietario (captación / contacto propietario). */
export function rolContactoCita(cita) {
  if (!cita) return "Contacto";
  const tipo = String(cita.tipo || "").toLowerCase();
  if (tipo === "captacion" || cita.captacion_id) return "Propietario";
  if (cita.cliente_id || cita.cliente_nombre) return "Cliente";
  if (cita.lead_id || cita.lead_nombre) return "Cliente";
  if (cita.contacto_id || cita.contacto_nombre) {
    const t = String(cita.contacto_tipo || "").toLowerCase();
    if (t.includes("propiet")) return "Propietario";
    return "Contacto";
  }
  return "Contacto";
}

export function nombreCaptacionCita(cita) {
  if (!cita) return "";
  return [cita.captacion_nombre, cita.captacion_apellido].filter(Boolean).join(" ").trim();
}

export function telefonoCaptacionCita(cita) {
  if (!cita?.captacion_telefono) return "";
  return String(cita.captacion_telefono).trim();
}

/** Línea 1: «10:00 Cliente Ana · 655127874» */
export function linea1BloqueCita(cita, { hora = "", nombre = "", telefono = "" } = {}) {
  const titulo = (cita?.titulo || "").trim();
  let nom = (nombre || "").trim();
  if (!nom && titulo) {
    const sinHora = titulo.replace(/^\d{1,2}:\d{2}\s*/, "").trim();
    nom = sinHora || titulo;
  }
  if (!nom) nom = "Sin nombre";
  const rol = rolContactoCita(cita);
  const tel = (telefono || "").trim();
  const base = `${hora} ${rol} ${nom}`.trim();
  return tel ? `${base} · ${tel}` : base;
}

/** Línea 2: «Agente Juan Pérez» */
export function linea2BloqueCita(cita) {
  if (!cita) return "";
  const agente = (cita.agente_nombre || cita.usuario_nombre || "").trim();
  if (!agente) return "";
  return `Agente ${agente}`;
}

export function tooltipBloqueCita(cita, opts = {}) {
  const tipo = cita?.tipo_etiqueta || etiquetaTipoAgenda(cita?.tipo);
  const l1 = linea1BloqueCita(cita, opts);
  const l2 = linea2BloqueCita(cita);
  return [tipo, l1, l2].filter(Boolean).join("\n");
}
